import React from "react";
import "./index.css";
import { Button } from "../Button/index";
import Android from "../../assets/android.svg"
import Apple from "../../assets/apple.svg"
export const HowItWorks = () => {
    return (
        <section className="hiw-bg my-3">
            <div className="container-art-1  py-5">
                <div className="d-flex justify-content-center align-item-center">
                    <div className="lead-sub">How it works</div>
                </div>
                <br />
                <br />
                <div className="row">
                    {[1, 2, 3]?.map((d, i) => {
                        return (
                            <div className="col-md-4 col-12 mb-4">
                                <div className="hiw-borders">
                                    <div>
                                        <div className="d-flex justify-content-center ">
                                            <div>
                                                <div className="hiw-circle">
                                                    <div className="d-flex h-100 text-white justify-content-center align-items-center hiw-no">{i +  1}</div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="text-center font-weight-bold hiw-title py-3">Describe your Project</div>
                                        <div className="text-center hiw-text">Tell us what you need done in detail and
                                            you will be matched  with the right professional.</div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}


                </div>
                <br />
                <br />
                <div className="d-flex justify-content-center align-items-center w-100 px-2">
                    <div>
                        <Button text="Create an Account" className="primary-button" />
                        <div className="text-center py-1">or</div>
                        
                        <div className="d-flex align-items-center">
                            <div className="mr-2">
                                <img src={Apple} />
                            </div>
                            <div className="">
                                <img src={Android} />
                            </div>

                        </div>
                    </div>
                </div>


            </div>
        </section>

    );
};

